import { comparer } from 'mobx'
import React, { useEffect, useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router'
import { RequestReportType } from 'views/NewReports/types/report.types'
import { getImageSrc } from '../../../helpers/getImageSrc'
import { isDealer } from '../../../services/AccountService'
import checkboxStore from '../../../stores/CheckboxStore'
import RequestFilterChip from '../../RequestsManagement/components/NewRequestFilters/components/RequestFilterChip'
import {
  singleReportFiltersStore,
  singleReportPaginationStore,
} from '../components/SingleReportTableFilters'
import { useDeleteRequestFromReport } from './useDeleteRequestFromReport'
import { useSingleReportTableData } from './useSingleReportTableData'

export const useSingleReportFilters = (
  reportId: number,
  report: RequestReportType,
) => {
  const intl = useIntl()
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const navigate = useNavigate()
  const onDelete = useDeleteRequestFromReport(reportId)
  const { getParams, setSelectedFilters, deleteFilter } =
    singleReportFiltersStore
  const { data } = useSingleReportTableData(reportId)
  const { setParams, setPage } = singleReportPaginationStore
  const { selectedIds } = checkboxStore
  useEffect(() => {
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current)
    }
  }, [])

  const onSearch = () => {
    const params = getParams()
    setSelectedFilters()
    setPage(0)

    return Promise.resolve(setParams(params))
  }

  const handleDeleteChip = (propName: string, multiselectValue: any) => {
    deleteFilter(propName, multiselectValue)

    timeoutRef.current && clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      onSearch()
    }, 0)
  }

  const setChip = (params: any, withAction: any) => (
    <RequestFilterChip {...params} onClick={withAction && handleDeleteChip} />
  )

  const actionBtnDisabled = !comparer.default(report.status, 1)
  const addIcon = actionBtnDisabled
    ? getImageSrc('addToReport')
    : getImageSrc('addToReportGray')

  const onAddReportClick = () => navigate(`/reports/${reportId}/add`)
  const onDeleteFromReport = (e: any) => onDelete(e, selectedIds)

  const adminButtonProps = isDealer() && {
    name: selectedIds.length ? (
      <FormattedMessage id={'Убрать из отчёта'} />
    ) : (
      <FormattedMessage id={'Добавить заявки...'} />
    ),
    onClick: selectedIds.length ? onDeleteFromReport : onAddReportClick,
    icon: selectedIds.length ? getImageSrc('massDelete') : addIcon,
    disabled: actionBtnDisabled,
    tooltip:
      report.status !== 1
        ? 'Добавление заявок в отчет доступно только для отчетов в статусе "Создан"'
        : null,
  }

  const getActionButtonProps = () => {
    return adminButtonProps
  }

  return {
    setChip,
    intl,
    data,
    onSearch,
    actionButtonProps: getActionButtonProps(),
  }
}
